import { mutationOptions } from '@tanstack/react-query';

import { API_SERVICE } from '@/constants/api.constant';
import { GET, POST } from '@/lib/fetch';
import type {
	LoginRequest,
	RefreshTokenRequest,
	RegisterRequest
} from '@/types/auth/auth.request';
import type {
	AuthResponse,
	RegisterResponse
} from '@/types/auth/auth.response';
import type { ErrorApiResponse, SuccessResponse } from '@/types/response';
import type { UserReponse } from '@/types/user/user.response';

type Token = {
	access_token: string,
	id_token: string,
	refresh_token: string
};

export const authQueries = {
	keys: () => 'auth' as const
};

export const authMutations = {
	login: mutationOptions<
		SuccessResponse<UserReponse>,
		ErrorApiResponse,
		LoginRequest & { onLogin: (token: Token) => void }
	>({
		mutationFn: async ({ onLogin, ...body }) => {
			const response = await POST<AuthResponse>(
				{
					path: '/auth/login',
					service: API_SERVICE.API
				},
				{ body }
			);

			onLogin(response.data);

			return GET({ path: '/users', service: API_SERVICE.API });
		},
		retry: 0
	}),
	refreshToken: mutationOptions<
		AuthResponse,
		ErrorApiResponse,
		RefreshTokenRequest
	>({
		mutationFn: (body) =>
			POST(
				{
					path: '/auth/refresh-token',
					service: API_SERVICE.API
				},
				{ body }
			)
	}),
	register: mutationOptions<RegisterResponse, ErrorApiResponse, RegisterRequest>(
		{
			mutationFn: (body) =>
				POST({ path: '/auth/registration', service: API_SERVICE.API }, { body }),
			retry: 0
		}
	)
};
